import { createSelector } from '@reduxjs/toolkit'

import { WHEEL_MODES, isLoyaltyMode } from 'components/WheelCard/config'
import { LoyaltyStatus } from 'src/containers/PulszPointsRewards/types'
import type { ReduxState } from 'src/store'
import { currentWheelSelector } from 'store/modules/bonusesFlow/selectors'
import { getUserPulszPointsLevelSelector } from 'store/modules/user/selectors'

export const getWheelOfWinnersConfig = (state: ReduxState) => state?.brandConfig?.wheelOfWinners

const getWheelConfigName = (state: ReduxState) => state?.brandConfig?.wheelConfigName

const getLoyaltyConfig = (state: ReduxState) => state?.brandConfig?.loyaltyConfig

const getWheelCardConfigRaw = (state: ReduxState) => state?.brandConfig?.wheelCard

const getPromoWheelConfigRaw = (state: ReduxState) => state?.brandConfig?.promoWheel

export const getWheelMode = createSelector(
  [getWheelConfigName, getUserPulszPointsLevelSelector, getLoyaltyConfig, currentWheelSelector],
  (brandConfigMode, vipLevelName, loyaltyConfig, wheelData): WHEEL_MODES => {
    const shouldShowLoyaltyWheel = wheelData?.code?.toLowerCase().includes('loyalty')
    const fallbackMode = (brandConfigMode as WHEEL_MODES) || WHEEL_MODES.default

    if (shouldShowLoyaltyWheel) {
      if (vipLevelName === LoyaltyStatus.LEGEND && loyaltyConfig?.legend?.isEnabled) {
        return WHEEL_MODES.loyalty_legend
      }

      if (vipLevelName === LoyaltyStatus.ICON && loyaltyConfig?.icon?.isEnabled) {
        return WHEEL_MODES.loyalty_icon
      }
    }

    return fallbackMode
  },
)

export const getPromoWheelConfig = createSelector(
  [getPromoWheelConfigRaw, getWheelMode, getLoyaltyConfig],
  (config, mode, loyaltyConfig) => {
    if (mode === WHEEL_MODES.loyalty_legend && loyaltyConfig?.legend) {
      return loyaltyConfig.legend
    }

    if (mode === WHEEL_MODES.loyalty_icon && loyaltyConfig?.icon) {
      return loyaltyConfig.icon
    }

    return config
  },
)

export const getWheelCardConfig = createSelector(
  [getWheelCardConfigRaw, getPromoWheelConfig, getWheelMode],
  (config, promoConfig, mode) => {
    if (isLoyaltyMode(mode) && promoConfig?.wheelCard) {
      return promoConfig.wheelCard
    }

    return config
  },
)
export const getCategoriesWith3DImages = (state: ReduxState) => state?.brandConfig?.categoriesWith3DImage
export const isSevenDaysRewardsEnabledSelector = (state: ReduxState) =>
  state?.brandConfig?.dailyRewardDialog?.sevenDaysRewardsEnabled
export const isWidgetsBarEnabledSelector = (state: ReduxState) => state?.brandConfig?.widgetsBar?.widgetsBarEnabled
export const getWidgetsConfig = (state: ReduxState) => state?.brandConfig?.widgetsBar?.widgets
export const getAdminOnlyWidgets = (state: ReduxState) => state?.brandConfig?.widgetsBar?.adminOnlyWidgets
